import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import { useTranslation } from 'react-i18next';
import './themeToggle.scss';

/**
 * Componente para alternar entre modo claro y oscuro
 */
const ThemeToggle = ({ className = '' }) => {
  const { toggleTheme, isDark } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      className={`theme-toggle-btn ${className}`}
      aria-label={isDark ? t("Cambiar a modo claro") : t("Cambiar a modo oscuro")}
      title={isDark ? t("Cambiar a modo claro") : t("Cambiar a modo oscuro")}
    >
      <div className="theme-toggle-icon-container">
        {isDark ? (
          // Icono de sol para modo oscuro (cambiar a claro)
          <svg 
            className="theme-toggle-icon"
            fill="currentColor" 
            viewBox="0 0 24 24" 
            width="20" 
            height="20"
          >
            <path d="M12 17.5c-3.033 0-5.5-2.467-5.5-5.5S8.967 6.5 12 6.5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zm0-9.5c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0-4a.75.75 0 01-.75-.75v-2a.75.75 0 011.5 0v2A.75.75 0 0112 4zm0 20a.75.75 0 01-.75-.75v-2a.75.75 0 011.5 0v2A.75.75 0 0112 24zM4 12a.75.75 0 01-.75.75h-2a.75.75 0 010-1.5h2A.75.75 0 014 12zm20 0a.75.75 0 01-.75.75h-2a.75.75 0 010-1.5h2A.75.75 0 0124 12zM6.343 6.343a.75.75 0 01-1.06 0l-1.415-1.415a.75.75 0 111.06-1.06l1.415 1.414a.75.75 0 010 1.061zm12.728 12.728a.75.75 0 01-1.06 0l-1.415-1.414a.75.75 0 111.06-1.061l1.415 1.414a.75.75 0 010 1.061zM19.071 6.343a.75.75 0 010-1.06l1.415-1.415a.75.75 0 111.06 1.06l-1.414 1.415a.75.75 0 01-1.061 0zM6.343 19.071a.75.75 0 010-1.06l1.414-1.415a.75.75 0 111.061 1.06l-1.414 1.415a.75.75 0 01-1.061 0z" />
          </svg>
        ) : (
          // Icono de luna para modo claro (cambiar a oscuro)
          <svg 
            className="theme-toggle-icon"
            fill="currentColor" 
            viewBox="0 0 24 24" 
            width="20" 
            height="20"
          >
            <path d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.752-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-6.998z" />
          </svg>
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;

